import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import MDEditor from '@uiw/react-md-editor';
import PreviousSvg from '../../../svg/student/Previous.js';
import NextSvg from '../../../svg/student/Next.js';
import ReloadSvg from '../../../svg/student/Reload.js';
import PopupWindow from './TextPopupWindow';

function Component(props) {
    const [isShowPopup, setisShowPopup] = useState(false)

    return (

        <div className='fixed top-0 left-0 w-full h-full flex flex-col gap-[16px] p-[16px] bg-[#00000090] justify-center items-center z-[9999]'>

            <div className='flex w-[90%] h-[90%] bg-[white] flex flex-col' style={{ overflowY: 'auto' }}>
                <div className='flex flex-col w-full bg-[#EEF2F6]' style={{ border: '10px solid #EEF2F6',borderBottom:'none' }}>
                    {/*tabs*/}
                    <div className='flex flex-row w-full items-end justify-start px-[16px] gap-[8px] pt-[6px] bg-[white]' style={{ border: '2px solid #D9D9D9' }} >
                        <div className='flex flex-row items-center gap-[8px] px-[12px] py-[4px] cursor-pointer hover:opacity-[.7] mb-[-2px]' style={{ backgroundColor: '#EEF2F6', borderTop: '2px solid #D9D9D9', borderLeft: '2px solid #D9D9D9', borderRight: '2px solid #D9D9D9', borderBottom: '2px solid #EEF2F6' }}>
                            {/* <div className='w-[20px] h-[20px] bg-[#eee] rounded-[7px]'>
                                    {page?.icon && <img src={page?.icon} alt='icon' className='w-full h-full object-cover' />}
                                </div> */}
                            <div className='text-[16px] font-[900]' style={{ color: 'black' }}>{props.page?.name}</div>
                        </div>

                    </div>
                    <div className='w-full flex flex-row bg-[white] p-[6px] gap-[6px] items-center mt-[12px]' style={{ borderBottom: '3px solid #E3E3E3' }}>
                        <div className='cursor-pointer'>
                            <PreviousSvg height={30} width={30} />
                        </div>
                        <div className='cursor-pointer'>
                            <NextSvg height={30} width={30} />
                        </div>
                        <div className='cursor-pointer'>
                            <ReloadSvg height={30} width={30} />
                        </div>
                        <div className='flex-1'>
                            <input disabled={true} className='w-full text-[16px] text-[black] h-[40px] ps-[24px] bg-[#EEF2F6] rounded-[4px]' value={props.page?.url || 'xxx.yyy.com'} />
                        </div>
                    </div>
                </div>
                <div className='w-full flex flex-col flex-1 relative' style={{ border: '10px solid #EEF2F6',borderTop:'none', overflowY: 'auto' }}>
                    {props.page?.contents?.map((c, ci) => {
                        if (props.data?.content_id && ci === props.data?.content_id && props.data?.popupStart && props.data.popupEnd) {
                            return {
                                ...c, text:
                                    c?.text?.slice(0, props.data?.popupStart)
                                    + '<span style="background-color:rgb(37, 124, 254); color: white;">' + c?.text?.slice(props.data?.popupStart, props.data?.popupEnd) + '</span>'
                                    + c?.text?.slice(props.data?.popupEnd)

                            }
                        } else return c
                    })?.map((item, index) =>
                        <div key={index} className='w-full flex flex-col rounded-[7px] gap-[8px]' style={item?.isCustom?(item?.customStyle||{}):{}}>
                            {item?.type?.includes('文章標題') && <div className='flex flex-col w-full gap-[8px]'>
                                <div className={`px-[16px] font-[700]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: item.type === '文章標題(左對齊)' ? 'left' : item.type === '文章標題(居中對齊)' ? 'center' : 'right' }}>
                                    <MDEditor.Markdown wrapperElement={{ "data-color-mode": "light" }} source={item?.text || ''} style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent", fontSize: 32 }} />
                                </div>
                            </div>}
                            {item?.type?.includes('閱讀文章內容') && <div className='flex flex-col w-full gap-[8px]'>
                                <div className={`px-[16px]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: item.type === '閱讀文章內容(左對齊)' ? 'left' : item.type === '閱讀文章內容(居中對齊)' ? 'center' : 'right' }}>
                                    <MDEditor.Markdown wrapperElement={{ "data-color-mode": "light" }} source={item?.text || ''} style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent" }} />
                                </div>
                            </div>}
                            {item?.type === '圖片' &&
                                <div className='w-full flex flex-col'>
                                    {item?.photo && <div className='relative w-full flex flex-row justify-center p-[16px]' style={{ backgroundColor: item?.backgroundColor || 'white' }}>
                                        {
                                            item?.photo
                                                ? <img style={{ height: 400, width: 400, objectFit: 'contain', maxWidth: '100%' }} src={item?.photo} alt='image' />
                                                : <div></div>
                                        }
                                    </div>}
                                </div>
                            }
                            {item.type === '超連結' && <div className='flex flex-col w-full gap-[8px]'>
                                <div className={`px-[16px]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: 'left' }}>
                                    <div cl style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent" }}>
                                        <div className='inline' dangerouslySetInnerHTML={{ __html: (item.redirects?.[0] ? item?.text?.slice(0, item.redirects?.[0]?.start) : item?.text) || '' }} />
                                        {item.redirects?.sort((a, b) => (a.start > b.start) ? 1 : (a.start < b.start) ? -1 : 0
                                        )?.map((r, ri) =>
                                            <div className='inline' key={ri}>
                                                <div className='inline text-[blue] cursor-pointer underline'
                                                    onClick={() => { }}
                                                    dangerouslySetInnerHTML={{ __html: item?.text.slice(r.start, r.end) }}
                                                />
                                                <div className='inline' dangerouslySetInnerHTML={{
                                                    __html:
                                                        item.redirects?.[ri + 1] ?
                                                            item?.text.slice(r.end, item.redirects?.[ri + 1].start)
                                                            : item?.text.slice(r.end)
                                                }} />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>}
                            {item.type === '彈出視窗' && <div className='flex flex-col gap-[8px]'>
                                <div className={`px-[16px]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: 'left' }}>
                                    <div cl style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent" }}>
                                        <div className='inline' dangerouslySetInnerHTML={{ __html: (item.popups?.[0] ? item?.text?.slice(0, item.popups?.[0]?.start) : item?.text) || '' }} />
                                        {item.popups?.sort((a, b) => (a.start > b.start) ? 1 : (a.start < b.start) ? -1 : 0
                                        )?.map((r, ri) =>
                                            <div className='inline' key={ri}>
                                                <div className='inline text-[blue] cursor-pointer' style={{textDecoration:item.noUnderline?'none':'underline'}} onClick={() => { setisShowPopup(r.text) }} dangerouslySetInnerHTML={{ __html: item?.text.slice(r.start, r.end) }} />
                                                <div className='inline' dangerouslySetInnerHTML={{
                                                    __html:
                                                        item.popups?.[ri + 1] ?
                                                            item?.text.slice(r.end, item.redipopupsrects?.[ri + 1].start)
                                                            : item?.text.slice(r.end)
                                                }} />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>}
                        </div>
                    )}
                    <div className='w-full min-h-[64px]'></div>
                </div>
            </div >
            <button className='flex justify-center items-center rounded-full bg-[white] cursor-pointer px-[20px] py-[10px] hover:opacity-[.5]' onClick={props.onClose}>
                <div>關閉</div>
            </button>
            {isShowPopup && <PopupWindow text={isShowPopup} onClose={() => { setisShowPopup(false) }} />}
        </div>
    )

}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
